module.exports = __webpack_public_path__ + "static/media/jlr-production-centre.c5ffc7e1.jpg";